/**
 * Header
 */

(function($) {
	$('#js-header-nav-toggle').on('click', function() {
		$('#header-nav').toggleClass('is-active');
		$(this).toggleClass('is-active');
	});
})(jQuery);